import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=0b240d58&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=ts&"
export * from "./orderPay.vue?vue&type=script&lang=ts&"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=0b240d58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b240d58",
  null
  
)

export default component.exports